import * as React from "react";
import { Chip } from "@mui/material";

interface ProviderBadgeProps {
  providerId: string;
  status?: string | null;
}

/** Displays a broker provider's id and its backend-reported connection status verbatim. */
export function ProviderBadge({ providerId, status }: ProviderBadgeProps): React.JSX.Element {
  return (
    <Chip
      size="small"
      variant="outlined"
      label={status ? `${providerId} — ${status}` : providerId}
    />
  );
}
